'use client'

import { Avatar, Icon, IconComponent } from '@graftcode/design-system'

import { MOBILE_MENU_TEST_IDS } from '@common/common-test-ids.const'

import { useMobileMenuContext } from '../../context'

import styles from '../../MobileMenu.module.scss'

type MobileMenuAccountSectionProps = {
  helpLabel?: string
}

export function MobileMenuAccountSection({ helpLabel = 'Help' }: MobileMenuAccountSectionProps) {
  const {
    displayProjectName,
    displayUserEmail,
    displayUserName,
    setIsAccountDrawerOpen,
    setIsHelpDrawerOpen,
    setIsProjectPickerOpen,
    showHelpSelector,
    showProjectSelector,
    showUserAvatar,
    userAvatarUrl,
  } = useMobileMenuContext()

  return (
    <div className={styles.accountSection} data-testid={MOBILE_MENU_TEST_IDS.accountSection}>
      <button className={styles.accountItem} onClick={() => setIsAccountDrawerOpen(true)}>
        <div className={styles.accountItemContent}>
          {showUserAvatar ? <Avatar size={32} src={userAvatarUrl} /> : null}
          <div className={styles.accountItemText}>
            <span className={styles.accountItemName}>{displayUserName}</span>
            <span className={styles.accountItemEmail}>{displayUserEmail}</span>
          </div>
        </div>
        <IconComponent icon={Icon.ChevronRightRegular} size={20} />
      </button>

      {showProjectSelector ? (
        <button className={styles.accountItem} onClick={() => setIsProjectPickerOpen(true)}>
          <div className={styles.accountItemContent}>
            <IconComponent icon={Icon.FolderRegular} size={20} />
            <span className={styles.projectName}>{displayProjectName}</span>
          </div>
          <IconComponent icon={Icon.ChevronRightRegular} size={20} />
        </button>
      ) : null}

      {showHelpSelector ? (
        <button className={styles.accountItem} onClick={() => setIsHelpDrawerOpen(true)}>
          <div className={styles.accountItemContent}>
            <IconComponent icon={Icon.QuestionCircleRegular} size={20} />
            <span className={styles.projectName}>{helpLabel}</span>
          </div>
          <IconComponent icon={Icon.ChevronRightRegular} size={20} />
        </button>
      ) : null}
    </div>
  )
}
